import "./TaskTags.css";

import { MandatoryFlagIcon } from "../../../assets/icons";

export type TaskTagsObjectType = "project" | "deal" | "landholding";
export type TaskTagsTaskType = "general" | "workflow";

export interface TaskTagsProps {
  isMandatory?: boolean;
  isMilestone?: boolean;
  /* "general" for a task with no workflow step, "workflow" otherwise. Omit to hide the chip. */
  taskType?: TaskTagsTaskType;
  /* Parent object the task hangs off. Omit to hide the chip. */
  objectType?: TaskTagsObjectType;
  /* Free-text tags, rendered as neutral chips after the derived ones. */
  extraTags?: string[];
}

const TASK_TYPE_LABELS: Record<TaskTagsTaskType, string> = {
  general: "General",
  workflow: "Workflow",
};

const OBJECT_TYPE_LABELS: Record<TaskTagsObjectType, string> = {
  project: "Project",
  deal: "Deal",
  landholding: "Landholding",
};

export const TaskTags = ({
  isMandatory = false,
  isMilestone = false,
  taskType,
  objectType,
  extraTags = [],
}: TaskTagsProps): JSX.Element | null => {
  if (!isMandatory && !isMilestone && !taskType && !objectType && extraTags.length === 0) {
    return null;
  }

  return (
    <div className="TaskTags">
      {isMandatory && (
        <span className="TaskTags_tag TaskTags_tag_mandatory">
          <MandatoryFlagIcon aria-hidden />
          Mandatory
        </span>
      )}
      {isMilestone && (
        <span className="TaskTags_tag TaskTags_tag_milestone">
          <span className="TaskTags_milestoneIcon" aria-hidden />
          Milestone
        </span>
      )}
      {taskType && <span className={`TaskTags_tag TaskTags_tag_${taskType}`}>{TASK_TYPE_LABELS[taskType]}</span>}
      {objectType && (
        <span className={`TaskTags_tag TaskTags_tag_${objectType}`}>{OBJECT_TYPE_LABELS[objectType]}</span>
      )}
      {extraTags.map((tag) => (
        <span key={tag} className="TaskTags_tag TaskTags_tag_extra">
          {tag}
        </span>
      ))}
    </div>
  );
};
